export default "__VITE_ASSET__DCajirS0__"